import { useState } from 'react';
import { Grid, TextField, Box, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link, useParams } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '../../Utils/RichEditor';
import CustomDatePicker from '../../Components/MUI/CustomDatePicker';
import { useGetEstimateListQuery } from '../../Redux/Service/EstimateApi';
import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import { useFindQuotationQuery, useGetQuotationStatusQuery } from '../../Redux/Service/QuotationApi';
import { useEffect } from 'react';
import { useGetCurrenciesQuery } from '../../Redux/Service/CurrencyApi';
import Loading from '../../Components/Loading';
import { API_URL } from '../../Config';
import StyledDashboardLayout from '../style';


function QuotationView() {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [symbol, setSymbol] = useState('USD');
    const { data: quotationData, isLoading: isLoadingForQuotation, isError: isErrorForQuotation, error: errorForQuotation } = useFindQuotationQuery(id);
    // const [lead, setLead] = useState({ name: '', email: '', phone: '' });
    const [opportunity, setOpportunity] = useState({ name: '' });
    const [serviceProvider, setServiceProvider] = useState({ name: '', email: '', phone: '' });
    const { data: estimateData, isLoading: isLoadingForEstimate, isError: isErrorForEstimate, error: errorForEstimate } = useGetEstimateListQuery();
    const { data: currencies, isLoading: isLoadingForCurrency } = useGetCurrenciesQuery();
    const { data: quotationStatus, isLoading: isLoadingForQuotationStatus } = useGetQuotationStatusQuery();

    useEffect(() => {
        if (!isLoadingForQuotation && !isErrorForQuotation && !isLoadingForCurrency && !isLoadingForQuotationStatus) {
            setOpportunity({ name: quotationData?.response?.estimate?.opportunity?.name });
            setServiceProvider({ name: quotationData?.response?.estimate?.serviceProvider?.name, email: quotationData?.response?.estimate?.serviceProvider?.email, phone: quotationData?.response?.estimate?.serviceProvider?.phoneNo });
            setSymbol(quotationData?.response?.currency?.symbol ?? 'USD');
            setLoading(false);
        }
    }, [quotationData, isLoadingForQuotation, isErrorForQuotation, isLoadingForCurrency, isLoadingForQuotationStatus])

    const handleSubTotal = (values) => {
        return values?.quotationDetails.reduce((acc, cur) => acc + Number(cur.total), 0);
    };

    const gstTotal = (values) => {
        const gstPercentage = Number(values.gstPercentage / 100);
        const gstTotal = Number(handleSubTotal(values) * gstPercentage);
        return gstTotal.toFixed(2);
    };

    const allTotal = (values) => {
        const alltotal = Number(Number(gstTotal(values)) + Number(handleSubTotal(values)));
        return alltotal.toFixed(2);
    };

    const quotationDetailsTotal = (id, values) => {
        const details = values.quotationDetails.filter((val) => val.id === id).map((val) => {
            val.total = ((Number(val.developmentTime) * 40) * Number(val.chargePerHour));
            return val;
        });
        handleSubTotal();
        return details[0]?.total ?? 0;
    }

    const currencySymbolSet = (currencyId, setFieldValue) => {
        setFieldValue('currencyId', currencyId)
        const findCurrency = currencies.response?.filter(val => val.id === currencyId);
        setSymbol(findCurrency[0]?.symbol ?? 'USD');
    }

    if (loading) {
        return <Loading />;
    }

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="d-flex justify-content-between mb-2">
                        <div className="pageTitle">
                            <h1 className="m-0">View Quotation</h1>
                        </div>
                        <div className="btnWrap">
                            <Link to="/quotation" className="btn addBtn"> <ArrowBackIcon /> Back</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card customCard p-3 m-3">
                {/* <div className="card-header">
                    <h3 className="card-title">Quotation</h3>
                </div> */}
                {isLoadingForQuotation ? (
                    <div>Loading...</div>
                ) : errorForQuotation ? (
                    <div>Error: {errorForQuotation?.message}</div>
                ) : (
                    <Formik
                        initialValues={{
                            id: quotationData?.response?.id,
                            estimateId: quotationData?.response?.estimate?.id || '',
                            userId: quotationData?.response?.userId || '',
                            name: quotationData?.response?.name || '',
                            place: quotationData?.response?.place || '',
                            description: quotationData?.response?.description || '',
                            validTimeDay: quotationData?.response?.validTimeDay || '',
                            gstPercentage: quotationData?.response?.gstPercentage || '',
                            date: quotationData?.response?.date || '',
                            quotationDetails: quotationData?.response?.quotationDetails || [],
                            currencyId: quotationData?.response?.currency?.id || 1,
                            quotationStatusId: quotationData?.response?.quotationStatus?.id || 1,
                            signature: quotationData?.response?.signature
                        }}>
                        {({ values, setFieldValue, touched, errors }) => (
                            <Form>
                                <Box className="card-body" sx={{ padding: "15px 0" }}>
                                    <Grid container spacing={4}>

                                        <Grid item xs={12}>
                                            <Box className="commonBox">
                                                <Typography variant="h6" gutterBottom>
                                                    Quotation
                                                </Typography>

                                                <Grid container spacing={4}>
                                                    <Grid item md={6} xs={12}>
                                                        <label htmlFor="date">Date</label>
                                                        <Field
                                                            component={CustomDatePicker}
                                                            label="Date"
                                                            name="date"
                                                            onChange={(date) => setFieldValue('date', date)}
                                                            fullWidth
                                                            readonly
                                                        />
                                                        <ErrorMessage name="date" component="div" style={{ color: 'red' }} />
                                                    </Grid>

                                                    <Grid item md={6} xs={12}>
                                                        <FormControl fullWidth>
                                                            <label htmlFor="quotationStatusId">Status</label>
                                                            <InputLabel id="status-label">Status</InputLabel>
                                                            <Field
                                                                label="Status"
                                                                name="quotationStatusId"
                                                                as={Select}
                                                                labelId="status-label"
                                                                onChange={(event) => setFieldValue('quotationStatusId', event.target.value)}
                                                            >
                                                                {quotationStatus?.response?.map((val, index) => (
                                                                    <MenuItem key={index} value={val.id}>{val.name}</MenuItem>
                                                                ))}
                                                            </Field>
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid item md={6} xs={12}>
                                                        <label htmlFor="validTimeDay">Valid For (Days)</label>
                                                        <Field
                                                            fullWidth
                                                            label="Valid For (Days)"
                                                            name="validTimeDay"
                                                            variant="outlined"
                                                            type="number"
                                                            as={TextField}
                                                            readonly
                                                            error={touched.validTimeDay && Boolean(errors.validTimeDay)}
                                                            helperText={touched.validTimeDay && errors.validTimeDay}
                                                        />
                                                    </Grid>
                                                    <Grid item md={6} xs={12}>
                                                        {isLoadingForEstimate ? (
                                                            <div>Loading...</div>
                                                        ) : isErrorForEstimate ? (
                                                            <div>Error: {errorForEstimate?.message}</div>
                                                        ) : (
                                                            <FormControl fullWidth>
                                                                <label htmlFor="estimateId">Estimates</label>
                                                                <InputLabel id="demo-select-small-label" sx={touched.estimateId && Boolean(errors.estimateId) ? { color: "hwb(353deg 2% 13%)" } : {}}>Estimates</InputLabel>
                                                                <Field
                                                                    label="Estimates"
                                                                    name="estimateId"
                                                                    as={Select}
                                                                    labelId="demo-select-small-label"
                                                                    id="demo-simple-select"
                                                                    readonly
                                                                >
                                                                    {estimateData?.response?.map((val, index) => (
                                                                        <MenuItem key={index} value={val.id}>{val.name}</MenuItem>
                                                                    ))}
                                                                </Field>
                                                            </FormControl>
                                                        )}
                                                    </Grid>

                                                    <Grid item md={6} xs={12}>
                                                        <FormControl fullWidth>
                                                            <label htmlFor="currencyId">Currency</label>
                                                            <InputLabel id="currency-label">Currency</InputLabel>
                                                            <Field
                                                                label="Currency"
                                                                name="currencyId"
                                                                as={Select}
                                                                labelId="currency-label"
                                                                onChange={(event) => currencySymbolSet(event.target.value, setFieldValue)}
                                                            >
                                                                {currencies?.response?.map((val, index) => (
                                                                    <MenuItem key={index} value={val.id}>{val.name} ({val.symbol})</MenuItem>
                                                                ))}
                                                            </Field>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>

                                            </Box>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Box className="commonBox">
                                                <Typography variant="h6" gutterBottom>
                                                    Service Provider
                                                </Typography>
                                                <Grid container spacing={2}>
                                                    <Grid item md={6} xs={12}>
                                                        <label htmlFor="name">Name</label>
                                                        <TextField fullWidth label="Name" variant="outlined" value={serviceProvider.name} readonly />
                                                    </Grid>
                                                    <Grid item md={6} xs={12}>
                                                        <label htmlFor="email">Email Address</label>
                                                        <TextField fullWidth label="Email Address" variant="outlined" type="email" value={serviceProvider.email} readonly />
                                                    </Grid>
                                                    <Grid item md={6} xs={12}>
                                                        <label htmlFor="phone">Phone Number</label>
                                                        <TextField fullWidth label="Phone Number" variant="outlined" value={serviceProvider.phone} readonly />
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Box className="commonBox">
                                                <Typography variant="h6" gutterBottom >
                                                    Client Details
                                                </Typography>
                                                <Grid container spacing={4}>
                                                    <Grid item xs={12}>
                                                        <label htmlFor="clientName">Name</label>
                                                        <TextField fullWidth label="Name" variant="outlined" value={opportunity.name} readonly />
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Box className="commonBox">
                                                <Typography variant="h6" gutterBottom >
                                                    Project Description
                                                </Typography>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <Field name="description">
                                                            {({ field }) => (
                                                                <CKEditor
                                                                    readonly
                                                                    editor={ClassicEditor}
                                                                    data={field.value}
                                                                    onChange={(event, editor) => setFieldValue('description', editor.getData())}
                                                                />
                                                            )}
                                                        </Field>
                                                        <ErrorMessage name="description" component="div" style={{ color: 'red' }} />
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Box className="commonBox">
                                                <Typography variant="h6" gutterBottom>
                                                    Development Time && Cost Detials
                                                </Typography>
                                                <FieldArray name="quotationDetails">
                                                    {(
                                                        <div>
                                                            {values.quotationDetails.map((val, index) => (
                                                                <Grid container spacing={2} key={val.id} sx={{ my: 1 }}>
                                                                    <Grid item xs={12}>
                                                                        <Grid container spacing={2}>
                                                                            <Grid item xs={1}></Grid>
                                                                            <Grid item xs={1}></Grid>
                                                                            <Grid item xs={4}>
                                                                                <Field
                                                                                    fullWidth
                                                                                    label="Description"
                                                                                    name={`quotationDetails.${index}.description`}
                                                                                    variant="outlined"
                                                                                    as={TextField}
                                                                                    readonly
                                                                                    error={touched.quotationDetails?.[index]?.description && Boolean(errors.quotationDetails?.[index]?.description)}
                                                                                    helperText={touched.quotationDetails?.[index]?.description && errors.quotationDetails?.[index]?.description}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={2}>
                                                                                <Field
                                                                                    fullWidth
                                                                                    label="Development Time (in weeks)"
                                                                                    name={`quotationDetails.${index}.developmentTime`}
                                                                                    variant="outlined"
                                                                                    type="number"
                                                                                    as={TextField}
                                                                                    readonly
                                                                                    error={touched.quotationDetails?.[index]?.developmentTime && Boolean(errors.quotationDetails?.[index]?.developmentTime)}
                                                                                    helperText={touched.quotationDetails?.[index]?.developmentTime && errors.quotationDetails?.[index]?.developmentTime}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={2}>
                                                                                <Field
                                                                                    fullWidth
                                                                                    label="Charge Per Hour"
                                                                                    name={`quotationDetails.${index}.chargePerHour`}
                                                                                    variant="outlined"
                                                                                    type="number"
                                                                                    as={TextField}
                                                                                    readonly
                                                                                    error={touched.quotationDetails?.[index]?.chargePerHour && Boolean(errors.quotationDetails?.[index]?.chargePerHour)}
                                                                                    helperText={touched.quotationDetails?.[index]?.chargePerHour && errors.quotationDetails?.[index]?.chargePerHour}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={2}>
                                                                                <TextField
                                                                                    fullWidth
                                                                                    label="Cost - Excluding GST"
                                                                                    variant="outlined"
                                                                                    type="text"
                                                                                    value={`(${symbol}) ${quotationDetailsTotal(val.id, values)}`}
                                                                                    readonly
                                                                                />
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            ))}
                                                        </div>
                                                    )}
                                                </FieldArray>

                                                <Grid container spacing={2} sx={{ mt: 4 }}>
                                                    <Grid item xs={12} sx={{ my: 2 }}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={8}></Grid>
                                                            <Grid item xs={2}>
                                                                <h4>Sub Total :</h4>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <Box sx={{ border: '1px solid grey', borderRadius: '5px', p: 2 }}>
                                                                    <b>({symbol})</b> {handleSubTotal(values)}
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={2}>
                                                                <Box sx={{ border: '1px solid grey', p: 1 }}>
                                                                    {(
                                                                        values.signature && (
                                                                            <img src={`${API_URL}${values.signature}`} alt="signature" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                                        )
                                                                    )}
                                                                </Box>
                                                            </Grid>
                                                            <Grid item xs={6}></Grid>
                                                            <Grid item xs={2}>
                                                                <h4>GST (%):</h4>
                                                            </Grid>
                                                            <Grid item xs={1}>
                                                                <Field
                                                                    fullWidth
                                                                    label="GST"
                                                                    name="gstPercentage"
                                                                    variant="outlined"
                                                                    type="number"
                                                                    readonly
                                                                    as={TextField}
                                                                    error={touched.gstPercentage && Boolean(errors.gstPercentage)}
                                                                    helperText={touched.gstPercentage && errors.gstPercentage}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={1}>
                                                                <Box sx={{ border: '1px solid grey', borderRadius: '5px', p: 2 }}>
                                                                    <b>({symbol})</b> {gstTotal(values)}
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={2} sx={{ mt: 1 }}>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={2}>
                                                                <Box sx={{ border: '1px solid grey', p: 1, }}>
                                                                    <b>Upload Signature</b>
                                                                </Box>
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                <Field
                                                                    fullWidth
                                                                    label="Place"
                                                                    name="place"
                                                                    variant="outlined"
                                                                    type="text"
                                                                    as={TextField}
                                                                    readonly
                                                                    error={touched.place && Boolean(errors.place)}
                                                                    helperText={touched.place && errors.place}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={3}></Grid>
                                                            <Grid item xs={2}>
                                                                <h4>Total :</h4>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <Box sx={{ border: '1px solid grey', borderRadius: '5px', p: 2 }}>
                                                                    <b>({symbol})</b> {allTotal(values)}
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Form>
                        )}
                    </Formik>
                )}
            </div>
        </div>
    );
}
export default QuotationView;